import { fromBaseRecord, type FromBaseRow } from './from-base-context';
import { readInventoryField } from './inventory-raw-readers';
import { mergeInventoryMetadata } from './inventory-shared-catalog';
import { memberConditionContext } from './member-condition-context';

/** Shared raw closure, without the source entity's saved identity or rows. */
export function encounterMemberSharedInputs(base: FromBaseRow): FromBaseRow {
    const sharedKeys = ['catalog', 'missing_definition_ids', 'enchantment_templates', 'enchantment_template_enchantments',
        'monster_templates', 'monster_template_layers', 'enchantment_match_candidates', 'enchantment_match_rows',
        'random_table_rows', 'definition_videos', 'pl_signature', 'inventory_metadata', 'picture_lookup_ids', 'picture_sources', 'inventory_order'];
    return Object.fromEntries(sharedKeys.filter(key => Object.prototype.hasOwnProperty.call(base, key)).map(key => [key, base[key]]));
}

/** The same complete saved inputs for an enclosing compile and a held member facet. */
export function encounterMemberInput(base: FromBaseRow, member: FromBaseRow, resolve?: (member: FromBaseRow) => FromBaseRow): FromBaseRow {
    // New statuses extend the enclosing closure after this member was captured.
    // Merge the raw witnesses too; an old member catalog/video list cannot shadow them.
    const input = mergeInventoryMetadata(member, encounterMemberSharedInputs(base));
    const catalog = fromBaseRecord(input.catalog) ? input.catalog : {};
    const ids = new Set((Array.isArray(member.inventory) ? member.inventory : []).map(row => readInventoryField(row, 'inventory_id')));
    return { ...input, catalog,
        encounter_context: memberConditionContext(base, member, resolve),
        missing_definition_ids: [...new Set([...(Array.isArray(base.missing_definition_ids) ? base.missing_definition_ids : []),
            ...(Array.isArray(member.missing_definition_ids) ? member.missing_definition_ids : [])])].filter(id => !catalog[String(id).toUpperCase()]),
        inventory_order: Array.isArray(base.inventory_order) ? base.inventory_order.filter(row => fromBaseRecord(row)
            && ids.has(readInventoryField({ inventory: row }, 'inventory_id'))) : undefined };
}
